import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
} from '@coreui/react-pro'
import { BlockAndUnblockDepositBonusClient } from '../../types'
import { banAndUnbanDepositBonusClientMounted } from '../../model'

type Props = {
  isVisible: boolean
  onClose: () => void
  clientId: string
  isBanned: boolean
}

export const BlockAndUnblockModal: React.FC<Props> = ({
  isVisible,
  onClose,
  clientId,
  isBanned,
}) => {
  const [data, setData] = useState<
    Omit<BlockAndUnblockDepositBonusClient, 'id'>
  >({
    isBanned: isBanned,
    banReason: '',
  })

  const handleChange = (event: {
    currentTarget: { name: any; value: any; checked?: any; type?: any }
  }) => {
    const name = event.currentTarget.name
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CModalBody>
        <CCol xs={8} className="mb-2">
          <>
            <div>
              <CFormCheck
                className="mb-2"
                name="isBanned"
                checked={data.isBanned}
                onChange={handleChange}
                label="Is Banned"
              />
            </div>
            <div>
              <CFormInput
                className="mb-2"
                type="text"
                name="banReason"
                placeholder="Ban reason"
                label="Ban reason"
                value={data.banReason}
                onChange={handleChange}
              />
            </div>
            <div>
              <CButton
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish baned or unbanned to ${clientId}?`,
                    )
                  ) {
                    banAndUnbanDepositBonusClientMounted({
                      id: clientId,
                      isBanned: data.isBanned,
                      banReason: data.banReason,
                    })
                    onClose()
                  }
                }}
              >
                Ok
              </CButton>
            </div>
          </>
        </CCol>
      </CModalBody>
    </CModal>
  )
}
